import { render, staticRenderFns } from "./DraftLawyerHistoryPart.vue?vue&type=template&id=b71d3096&scoped=true&"
import script from "./DraftLawyerHistoryPart.vue?vue&type=script&lang=js&"
export * from "./DraftLawyerHistoryPart.vue?vue&type=script&lang=js&"
import style0 from "./DraftLawyerHistoryPart.vue?vue&type=style&index=0&id=b71d3096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71d3096",
  null
  
)

export default component.exports